import reduxLogger from 'redux-logger';

import * as consts from '../../constants';

const ommitTypes = [
  consts.SET_WINDOW_VIEWPORT,
  consts.SET_PRINT_VIEWPORT,
  consts.CHANGE_CENTER,
  consts.FETCH_HOTELS_REQUEST,
  consts.FETCH_POIS_REQUEST,
  consts.FETCH_POIS_PROPS_REQUEST,
  consts.FETCH_HOTELS_PROPS_REQUEST,
  consts.FETCH_HOTELS_SUCCESS,
  consts.FETCH_POIS_SUCCESS,
  consts.FETCH_POIS_PROPS_SUCCESS,
  consts.FETCH_HOTELS_PROPS_SUCCESS,
];

export default function createLogger() {
  return reduxLogger({
    collapsed: true,
    predicate: (getState, action) => ommitTypes.indexOf(action.type) === -1,
  });
}



// WEBPACK FOOTER //
// src/store/logger/logger.client.js